import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-information',
    templateUrl: './information.component.html',
    styleUrls: ['./information.component.css'],
    standalone: false
})
export class InformationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
